import storage from '@/fetch/storage'

export const DEFAULT_LOGIN_PATH = '/yssz/login'
export const LAST_TENANT_ID = 'lastTenantId'
const LEGACY_LAST_TENANT_KEY = 'lastTenantKey'

export function getTenantIdFromPath(path = '') {
  const match = path.match(/^\/t\/([1-9]\d*)(?:\/|$)/)
  return match ? match[1] : ''
}

export function stripTenantPrefix(path = '') {
  const tenantId = getTenantIdFromPath(path)
  if (!tenantId) return path
  const stripped = path.replace(/^\/t\/[1-9]\d*/, '')
  return stripped || '/'
}

export function saveTenantId(tenantId) {
  storage.remove(LEGACY_LAST_TENANT_KEY)
  if (tenantId && /^[1-9]\d*$/.test(String(tenantId))) {
    storage.set(LAST_TENANT_ID, String(tenantId))
  } else {
    storage.remove(LAST_TENANT_ID)
  }
}

export function getStoredTenantId() {
  const tenantId = storage.get(LAST_TENANT_ID)
  return tenantId && /^[1-9]\d*$/.test(String(tenantId)) ? String(tenantId) : ''
}

export function getTenantLoginPath(route) {
  const tenantId = getTenantIdFromPath(route && route.path) || getStoredTenantId()
  return tenantId ? `/t/${tenantId}/login` : DEFAULT_LOGIN_PATH
}

export function syncTenantIdFromRoute(route) {
  const path = route && route.path ? route.path : ''
  const tenantId = getTenantIdFromPath(path)
  if (tenantId) {
    saveTenantId(tenantId)
  } else if (path.includes('/login')) {
    saveTenantId('')
  }
  return tenantId
}
